import client from '../client'

export const getDecodeModelsKey = `${process.env.NEXT_PUBLIC_INTEGRATION_DATAKIOSK_ENDPOINT}/GetDecodeModels`

export async function getDecodeModels({ year, makeId }) {
  const params = new URLSearchParams({ year: year.toString(), makeId: makeId.toString() })

  return client(`${getDecodeModelsKey}?${params.toString()}`)
}
